<template>
  <v-simple-table dense
    class="misc-expandable-row-table"
    id="miscExpandableRowTable"
  >
      <thead>
          <tr>
            <th
              v-for="(item, index) in tableHeader"
              :key="'table-header-' + index"
              :class="item.cssClass"
            >
              {{ item.title }}
            </th>
          </tr>
      </thead>
      <tbody>
          <tr
            v-for="(item, index) in ((updatedTrans || {}).details || [])"
            :key="'table-row-' + index"
          >
            <td>{{ item.fundAndDesc }}</td>
            <td>{{ item.sourceSubSourceNumber }}</td>
            <td>{{ item.sourceDescription }}</td>
            <td>{{ item.unitCodeAndDesc }}</td>
            <td style="text-align: right">{{ amountFormat(item.amount) }}</td>
            <td v-if="index === 0"
              :rowspan="(updatedTrans.details || []).length"
            >
                {{ updatedTrans.description }}
            </td>
          </tr>
      </tbody>
  </v-simple-table>
</template>

<script>
import { amountFormat } from '../../../util/shared/vue-global';

export default {
  name: 'MiscExpandableRow',
  data: () => ({
    tableHeader: [
      { title: 'Fund', cssClass: 'misc-expandable-row-header' },
      { title: 'Source', cssClass: 'misc-expandable-row-header' },
      { title: 'Source Description', cssClass: 'misc-expandable-row-header' },
      { title: 'Unit Code', cssClass: 'misc-expandable-row-header' },
      { title: 'Amount', cssClass: 'misc-expandable-row-header' },
      { title: 'Description', cssClass: 'misc-expandable-row-header' },
    ],
  }),
  props: {
    baseCrudKey: {
      type: String,
      default: 'MiscExpandableRowKey',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    updatedTrans() {
      const updatedItem = { ...this.item };
      updatedItem.details = ((updatedItem || {}).details || []).map((d) => ({
        fundAndDesc: `${((d.fund || {}).fund || '')}-${((d.fund || {}).description || '')}`,
        sourceSubSourceNumber: `${(d.source || {}).sourceSubSourceNumber || ''}`,
        sourceDescription: `${(d.source || {}).sourceDescription || ''} - ${(d.source || {}).subSourceDescription || ''}`,
        unitCodeAndDesc: `${(d.unit || {}).unitCodeNumber || ''} - ${(d.unit || {}).description || ''}`,
        ...d,
      }));
      return updatedItem;
    },
  },
  methods: {
    amountFormat,
  },
};

</script>

<!-- The header band used to be the Vuetify colour class `blue lighten-5` (was:
     cssClass: 'blue lighten-5'), which is a literal near-white blue. It survived the
     switch to the dark theme unchanged while Vuetify turned the header text white, so
     the expanded detail table's headings were white-on-pale-blue. The fill now follows
     the theme var from assets/style.css - `blue lighten-5` itself as the light value, a
     translucent blue over the dark surface on dark - so the tint still reads as a
     header band in both themes. -->
<style scoped>
.misc-expandable-row-table th.misc-expandable-row-header {
  background-color: var(--subtable-header-bg, #e3f2fd);
}
</style>
